import SearchFormDateRecurrence from './SearchFormDateRecurrence';

export default SearchFormDateRecurrence;
